import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL = 100;
export function ScarcityBar() {
  const [left, setLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(l => l > 3 ? l - 1 : l);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const pct = (TOTAL - left) / TOTAL * 100;
  return <div className="w-full max-w-xl" data-id="element-57" data-mp="2b5yty3b8brby">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-58" data-mp="2b935xmuxrrd6">
        <span className="flex items-center gap-1.5 text-danger" data-id="element-59" data-mp="2g74p07sd3qon">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="2273lslomk760" />
          Only {left} spots left at $27
        </span>
        <span className="text-white/80" data-id="element-61" data-mp="275oocrrcn2xm">{Math.round(pct)}% claimed</span>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-62" data-mp="fqks7ps2jf8">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: '60%'
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="2zlje85gic9tb" />
      </div>
      <p className="mt-2 text-xs text-white/70" data-id="element-64" data-mp="38fxrk2hh9a9s">
        When the remaining spots are claimed, the promotional price is no longer guaranteed.
      </p>
    </div>;
}